import { get, post, type RequestConfig } from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  OfflineDonation,
  OfflineDonationPayload,
} from "@project/types/offline-donation";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/offline-donations`;
const SILENT: RequestConfig = { showNotification: false };

class OfflineDonationService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<OfflineDonation>> =>
    fetchListPage<OfflineDonation>(`${BASE}/`, query);

  get = async (id: number): Promise<OfflineDonation | undefined> => {
    const data = await get<ApiItemResponse<OfflineDonation> | OfflineDonation>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (
    payload: OfflineDonationPayload
  ): Promise<OfflineDonation | undefined> => {
    const data = await post<
      ApiItemResponse<OfflineDonation> | OfflineDonation,
      OfflineDonationPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };
}

export const offlineDonationService = new OfflineDonationService();
